import { DotDangKySerVice } from "../services/dotdangky.service";

var state = {
	dotdangky: {
		dotDangKyId: 0,
		maDot: "",
		tenDot: "",
		loaiDot: "",
		ngayBatDau: "",
		ngayKetThuc: "",
		ngayCongBo: "",
	},
	dotdangkies: [],
	loaidots: [],
};

var getters = {};

var mutations = {
	getDotDangKies(state, data) {
		state.dotdangkies = [...data.sort((a, b) => (a.thuTu < b.thuTu) ? -1 : 1)];
	},

	getDotDangKy(state, data) {
		state.dotdangky = data;
	},

	getLoaiDots(state, data) {
		state.loaidots = data;
	},
};

var actions = {
	getDotDangKies({ commit }) {
		return DotDangKySerVice.getDotDangKies()
			.then(async (response) => {
				if (response.status === 200)
					await commit("getDotDangKies", response.data);
				return response;
			})
			.catch((error) => error.message);
	},

	getDotDangKy({ commit }, dotDangKyId) {
		return DotDangKySerVice.getDotDangKy(dotDangKyId)
			.then((response) => {
				if (response.status === 200) commit("getDotDangKy", response.data);
				return response;
			})
			.catch((error) => error.message);
	},

	getDotDangKyHocBaHT({ commit }) {
		return DotDangKySerVice.getDotDangKyHocBaHT()
			.then(async (response) => {
				if (response.status === 200)
					await commit("getDotDangKy", response.data);
				return response;
			})
			.catch((error) => error.message);
	},

	getLoaiDots({ commit }) {
		return DotDangKySerVice.getLoaiDots()
			.then((response) => {
				if (response.status === 200) commit("getLoaiDots", response.data);
				return response;
			})
			.catch((error) => error.message);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
